import React, { useState } from "react";
import { FaRegFileAlt } from "react-icons/fa";
import api from "../../api/api";
import SummaryModal from "./modals/summarymodal";
import FileViewerModal from "./modals/FileViewrModal";
import FullScreenLabDetailsModal from "./modals/fulscreenlabmodal";
import { CircularProgress } from "@mui/material";
import { share, smart } from "./utils/svg";
import hubApi from "api/hubapi";
import SmartQuestionsShareModal from "./modals/expandmodals/smartquestionmodal";

const SmartQuestions = ({ data, view }) => {
  const patient_insights = data;

  const [openQuestionModal, setOpenQuestionModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [summaryHtml, setSummaryHtml] = useState('');
  const [loadingSummary, setLoadingSummary] = useState(false);
const[imageModalOpen, setImageModalOpen] = useState(false);
const[imagedata, setImageData] = useState(null);
const [labsModal,setLabsModal] = useState(false);
const [labsData,setLabsData] = useState(null);
const [shareModalOpen, setShareModalOpen] = useState(false);
const [loadingDetails, setLoadingDetails] = useState(false);
  const truncateText = (text, maxLength = 50) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };

  const handleQuestionModalOpen = (question) => {
    setSelectedQuestion(question.question);
    setOpenQuestionModal(true);
  };

  const handleSummaryModalOpen = async (questionObj) => {
 
    setSummaryHtml("");
setLoadingDetails(true)

    try {
      const sourceNodeId = questionObj.source_node_id?.[0];
      if (!sourceNodeId) throw new Error("Missing source_node_id");

      const parsed = JSON.parse(sourceNodeId);
      const { url, http_method, payload } = parsed;
      const relativeUrl = url.replace(/^https:\/\/[^/]+\/ag/, "");

      let response;
      if (http_method?.toLowerCase() === "post") {
        response = await hubApi.post(relativeUrl, JSON.parse(payload));
      } else {
        response = await hubApi.get(relativeUrl);
      }

    
if (response && typeof response === 'object' && 'files' in response) {
  setImageData(response);
  setImageModalOpen(true);
} else if (
  response &&
  typeof response === 'object' &&
  'data' in response &&
  typeof response.data === 'object' &&
  response.data !== null &&
  'dates' in response.data
) {
  console.log(response.data, 'labs data received');
  setLabsData(response.data || []);
  setLabsModal(true);
} else if (
  response &&
  typeof response === 'object' &&
  'data' in response &&
  typeof response.data === 'object' &&
  response.data !== null &&
  'summaryhtml' in response.data
) {
  setSummaryHtml(response.data || []);
  setOpenSummaryModal(true);
} else {
  console.warn("Unexpected response format:", response);
}
    } catch (error) {
      console.error("Error loading summary:", error);
      setSummaryHtml("<div class='text-red-500'>Error loading summary.</div>");
    } finally {
   setLoadingDetails(false)
    }
  };

  const handleCloseModals = () => {
    setOpenQuestionModal(false);
    setSelectedQuestion("");
  };

  const handleCloseSummaryModal = () => {
    setOpenSummaryModal(false);
    setSummaryHtml("");
    setLoadingSummary(false);
  };

  return (
    <>
      <div className="h-full flex">
    <div
  className="bg-white text-xs p-2 text-start h-full"
  style={{
    borderRadius: '8.75px',
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
  }}
>  <div className="flex justify-between items-center px-3 py-2 rounded-t-md">
             {/* Left Side: Icon + Label + Issues */}
             <div className="flex items-center gap-2 text-[#2C5282] font-semibold text-lg">
               {smart}
               <span>Smart Questions</span>
               
             
             </div>
           
             {/* Right Side: Share Icon */}
           {!view==1&&<div onClick={() => setShareModalOpen(true)} className="cursor-pointer">
  {share}
</div>}
           </div>

          {/* Body */}
          <div className="p-3 flex-1 space-y-2">
            {patient_insights?.smart_questions?.questions?.map((q, index) => (
              <div
                key={index}
                className={`flex items-center justify-between border-b ${view === 1 ? "py-2" : "py-1"}`}
              >
                <div
                  className={`italic cursor-pointer ${view === 1 ? "text-sm" : "text-xs"}`}
                  onClick={() => handleQuestionModalOpen(q)}
                >
                  {view === 1 ? q.question : truncateText(q.question)}
                </div>
                {q.source_node_id?.length > 0&& (
                  <FaRegFileAlt
                    className="text-blue-500 cursor-pointer text-sm ml-2"
                    onClick={() => handleSummaryModalOpen(q)}
                    title="View Summary"
                  />
                )}
              </div>
            ))}

            {view === 1 && (
              <div className="mt-6">
                <div className="flex flex-wrap gap-2">
                  {patient_insights?.smart_questions?.actions.map((action, index) => (
                    <div
                      key={index}
                      className="bg-blue-500 text-white text-xs font-medium px-3 py-2 rounded-md border border-blue-200 shadow-sm"
                    >
                      {action}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Question Modal */}
      {openQuestionModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
          <div className="bg-white rounded text-start shadow-md w-[90%] max-w-md p-4 relative">
            <button className="absolute top-2 right-3 text-gray-500 text-xl" onClick={handleCloseModals}>
              &times;
            </button>
            <h2 className="text-blue-600 font-semibold text-sm border-b pb-2 mb-2">Smart Question</h2>
            <div className="font-semibold text-sm mb-1">Full Question:</div>
            <div className="italic text-sm text-gray-800 mb-4">"{selectedQuestion}"</div>
          </div>
        </div>
      )}

  {loadingDetails && (
  <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
    <div className="bg-white rounded-md p-6 shadow-md flex flex-col items-center gap-2">
      <span className="text-gray-700">Loading ...</span>
      <CircularProgress size={24} />
    </div>
  </div>
)}

 <SummaryModal
        open={openSummaryModal}
        onClose={() => {
          setOpenSummaryModal(false);
          setSummaryHtml("");
        }}
        htmlContent={
        loadingDetails ? (
            `<div class="flex justify-center items-center h-40"><div class="text-center"><svg class="animate-spin h-6 w-6 text-blue-600 mx-auto" viewBox="0 0 24 24"></svg><p>Loading...</p></div></div>`
          ) : (
            summaryHtml
          )
        }
      />
      <SmartQuestionsShareModal
  open={shareModalOpen}
  onClose={() => setShareModalOpen(false)}
  data={patient_insights}
/>
{imageModalOpen && imagedata && (<FileViewerModal open={imageModalOpen} onClose={()=>{
  setImageData(null)
  setImageModalOpen(false)
}} data={imagedata}/>)}
      {labsModal && !loadingDetails && labsData && (
        <FullScreenLabDetailsModal
          open={labsModal}
          onClose={() => {
            setLabsModal(false);
            setLabsData(null);
          }}
          data={labsData}
        />
      )}

    </>
  );
};

export default SmartQuestions;
